import React, {useContext, useEffect, useState} from 'react'
import {withRouter} from 'react-router-dom'
import {Page_settings} from '../../config/page_settings'
import strings from '../../lang/strings'
import {observer} from 'mobx-react'
import PageSubHeader from '../../components/common/page_sub_header'
import {rootStore} from '../../mobx/store'

const Term = observer((props) => {
  const context = useContext(Page_settings)
  let [termContent, setTermContent] = useState('')
  let [title, setTitle] = useState('')
  let [active, setActive] = useState(2)

  useEffect(() => {
    init()
  }, [props.type])

  const init = () => {
    let type = parseInt(props.type)
    
    let params = ''
    if (type === 0) {
      setTitle(strings.po_terms)
      setActive(2)
      params = 'po_terms'
    } else if (type === 1) {
      setTitle(strings.po_privacy)
      setActive(3)
      params = 'po_privacy'
    } else if (type === 2) {
      setTitle(strings.po_refund)
      setActive(-1)
      params = 'po_refund'
    } else if (type === 3) {
      setTitle(strings.po_company)
      setActive(-1)
      params = 'po_company'
    }

    context.post('conf/get_conf', {type: params},
      response => {
        setTermContent(response.conf)
        if (rootStore.isSignedIn) {
          let mb = rootStore.getMe
          mb.mb_point = response.mb_point
          rootStore.signIn(mb)
        }
      },
      false,
      err => {
        context.showAlert(err.msg)
      }
    )
  }

  return (
    <React.Fragment>
        <div className={'mt-30'}>
          <PageSubHeader pageName={title} pageMenu1={strings.main} pageMenu2={strings.cs_center} pageMenu={title}/>
          <div className='term-content-area sm-ph-20 fs-16 sm-fs-14 f-m' dangerouslySetInnerHTML={{ __html: termContent }} />
        </div>
    </React.Fragment>
  )
})

export default withRouter(Term)
